// const platformIsTaiwan = ~location.pathname.indexOf('taiwan');
import qs from 'query-string';
const parsed = qs.parse(location.search);

const platformIsEshop = ~location.href.indexOf('eshop');
const platformIsLocalhost = ~location.href.indexOf('localhost');
const platform = platformIsEshop ? 'eshop' : 'taiwan';


const oosCsid = parsed && parsed.oosCsid ? ('?oosCsid=' + parsed.oosCsid) : '';

const API_URL = (!platformIsLocalhost ? `${location.origin}/${platform}/cart.php` : 'https://192.168.11.36/eshop/cart.php') + oosCsid;
const ACTION_URL = (!platformIsLocalhost ? `${location.origin}/${platform}/shopping_cart.php` : 'https://192.168.11.36/eshop/shopping_cart.php') + oosCsid;
const DEFAULT_URL = (!platformIsLocalhost ? `${location.origin}/${platform}/index.php` : 'https://192.168.11.36/eshop/index.php') + oosCsid;


export default {
    API_URL: API_URL,
    ACTION_URL: ACTION_URL,
    DEFAULT_URL: DEFAULT_URL,
    platformIsLocalhost: platformIsLocalhost
};


// WEBPACK FOOTER //
// ./src/setting.js